<template>
  <div class="v-data-footer">
    <v-row class="pt-5">
      <v-col>
        <v-select
          :menu-props="{ offsetY: true }"
          append-to-body
          outlined
          dense
          label="Export"
          v-model="exportSelected"
          :items="exportTypes"
          item-text="name"
          item-value="value"
          data-cy="exportSelect"
        />
      </v-col>

      <v-col cols="auto">
        <v-btn
          :disabled="disabledExportButton"
          height="40"
          color="primary"
          :loading="exportLoading"
          depressed
          @click="exportData($event)"
        >
          Export do xlsx
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import requestUrlFunction from '@/utils/requestUrl';
import { downloadFile } from '@/components/mixins/downloadFile';

export default {
  name: 'RequestsFooter',
  mixins: [downloadFile],
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      exportSelected: null,
      exportLoading: false,
    };
  },
  computed: {
    exportTypes() {
      return [
        {
          name: 'Exportovat zobrazená data',
          value: 'showedData',
        },
        {
          name: 'Exportovat vybraná data',
          value: 'selectedData',
          disabled: !this.selectedIds.length,
        },
        {
          name: 'Exportovat všechna vyfiltrovaná data',
          value: 'filteredData',
        },
        {
          name: 'Exportovat všechna data',
          value: 'allData',
        },
      ];
    },
    selectedIds() {
      return this.value.selectedData.items.map((item) => item.id);
    },
    disabledExportButton() {
      if (!this.exportSelected) {
        return true;
      }
      if (this.exportSelected === 'selectedData' && !this.selectedIds.length) {
        return true;
      }
      return false;
    },
  },
  methods: {
    exportData(event) {
      this.exportLoading = true;

      if (this.exportSelected === 'showedData') {
        this.downloadFile(
          event,
          `requests/export${requestUrlFunction(this.value.selectedData.params)}`,
        ).finally(() => {
          this.exportLoading = false;
        });
      } else if (this.exportSelected === 'selectedData') {
        const ids = this.value.selectedData.items
          .map((item) => item.id)
          .join('&ids=');

        this.downloadFile(event, `requests/export?ids=${ids}&size=${this.value.selectedData.items.length}`).finally(() => {
          this.exportLoading = false;
        });
      } else if (this.exportSelected === 'filteredData') {
        this.downloadFile(event, `requests/export${requestUrlFunction(this.value.selectedData.params, false)}`).finally(() => {
          this.exportLoading = false;
        });
      } else if (this.exportSelected === 'allData') {
        let sort = '';
        if (
          this.value.selectedData.params.options.sortBy
          && this.value.selectedData.params.options.sortBy.length
        ) {
          sort = this.value.selectedData.params.options.sortBy
            ? `${this.value.selectedData.params.options.sortBy},${this.value.selectedData.params.options.sortDesc[0]
              ? 'desc' : 'asc'}` : '';
          sort = `sort=${sort}`;
        }
        this.downloadFile(event, `requests/export?size=${this.value.totalElements}&${sort}`).finally(() => {
          this.exportLoading = false;
        });
      }
    },
  },
};
</script>
